import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import {auth} from "../firebase";
import { sendPasswordResetEmail } from '@firebase/auth';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./ResetPassword.css";

function ResetPasswordPage(props) {

  console.log('Loading <ResetPasswordPage> component...');

  // Enable page redirects
  let navigate = useNavigate();

  // Keep track of user data entered into form
  const [email, setEmail] = useState("");

  // Handle reset event
  const onReset = (e) => {

    // Send email
    sendPasswordResetEmail(auth, email)
      .then(() => {
        toast.info('Email sent. If the address provided has previously been registered, check your email (spam folder too) and follow the instructions to reset your password.')
      })
      .catch((error) => {
        console.log(error);
        toast.error(`The entered email address was not found in the registration database. Please try again and contact the site administrator if needed.`)    // notify user
      });

    // Redirect to home
    // navigate('/');
  }

  return (
    <div className='sign-in-container'>
      <form className="resetPasswordForm" onSubmit={onReset}>
        <h1>Reset your Password</h1>
        <br></br>
        <br></br>
        <input
          className="inputField"
          type="email"
          placeholder="Enter your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        ></input>
        <button className="authButton" type="submit">Reset</button>
        <h4><em>* input email address must already be registered for reset to work</em></h4>
      </form>
    </div>
  );
}

export default ResetPasswordPage;